export default __webpack_public_path__ + "static/media/hussain_1.c2647af4.jpg";